import React from 'react';
import Icon from '../Icon';
import PropTypes from 'prop-types';

const Button = ({ text, className, onClick, disabled = false, icon }) => {
  return (
    <button type="button" disabled={disabled} className={`button ${className}`} onClick={onClick}>
      {text}
      <Icon name={icon} className="button__icon"/>
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string
};

Button.defaultProps = {
  className: '',
  onClick: () => {},
  icon: ''
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js